export const name = 'instagram';

export const Instagram = () => (
  <svg
    viewBox="0 0 24 24"
    color="#161619"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2295_20137)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.85555 2.25785C4.04034 2.25785 1.75785 4.54034 1.75785 7.35555V17.6444C1.75785 20.4597 4.04034 22.7421 6.85555 22.7421H16.4978C19.313 22.7421 21.5955 20.4597 21.5955 17.6444V7.35555C21.5955 4.54034 19.313 2.25785 16.4978 2.25785H6.85555ZM0 7.35555C0 3.5695 3.0695 0.5 6.85555 0.5H16.4978C20.2838 0.5 23.3533 3.5695 23.3533 7.35555V17.6444C23.3533 21.4305 20.2838 24.5 16.4978 24.5H6.85555C3.0695 24.5 0 21.4305 0 17.6444V7.35555Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6454 8.23883C9.36468 8.17242 7.44905 10.1028 7.44905 12.4669C7.44905 14.8018 9.3418 16.6945 11.6767 16.6945C13.9905 16.6945 15.8525 14.8177 15.9045 12.4434L15.9045 12.4433C15.9317 11.2108 15.5662 10.2012 14.9047 9.49501C14.2481 8.79414 13.1986 8.28404 11.6454 8.23883L11.6454 8.23883ZM11.7079 6.09126C8.13535 5.98723 5.30057 8.97468 5.30057 12.4669C5.30057 15.9884 8.15523 18.843 11.6767 18.843C15.2191 18.843 17.9762 15.9714 18.0525 12.4904C18.0896 10.8048 17.5867 9.21542 16.4726 8.02617C15.3536 6.83159 13.7201 6.14983 11.7079 6.09126ZM16.9785 12.4669L18.0525 12.4904L16.9785 12.4669Z"
        fill="currentColor"
      />
      <path
        d="M18.2072 7.39766C19.0284 7.39766 19.6941 6.73196 19.6941 5.91078C19.6941 5.08959 19.0284 4.42389 18.2072 4.42389C17.386 4.42389 16.7203 5.08959 16.7203 5.91078C16.7203 6.73196 17.386 7.39766 18.2072 7.39766Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2295_20137">
        <rect
          width="24"
          height="24"
          fill="#ffffff"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
